var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3077 8V12.5H20.9975C21.5512 12.5 22 12.9477 22 13.5V19C22 19.5523 21.5512 20 20.9975 20H18.1365V17C18.1365 16.5858 17.7999 16.25 17.3846 16.25C16.9694 16.25 16.6327 16.5858 16.6327 17V20H13.5211V15.5C13.5211 15.0858 13.1845 14.75 12.7692 14.75C12.354 14.75 12.0174 15.0858 12.0174 15.5V20H8.90573V17C8.90573 16.5858 8.5691 16.25 8.15385 16.25C7.73859 16.25 7.40197 16.5858 7.40197 17V19.9778C4.35795 19.7971 2 18.5328 2 17V8C2 6.34315 4.75517 5 8.15385 5C11.5525 5 14.3077 6.34315 14.3077 8ZM11.2308 8C11.2308 7.17157 9.85318 6.5 8.15385 6.5C6.45451 6.5 5.07692 7.17157 5.07692 8C5.07692 8.82843 6.45451 9.5 8.15385 9.5C9.85318 9.5 11.2308 8.82843 11.2308 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureTape);
export default __webpack_public_path__ + "static/media/measure-tape.a1af877b7c509894a78592e5209277fd.svg";
export { ForwardRef as ReactComponent };